import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Grid, MenuItem, Select, FormControl } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { supportedIntegrationsByLocale } from 'src/modules/Settings/Integrations/pages/IntegrationsList/hooks';
import { selectCompany } from 'src/old/actions/company/companySelectors';

const useStyles = makeStyles(theme => ({
  selectRoot: {
    width: '100%'
  },
  formControlRoot: {
    width: '100%'
  },
  optionWrapper: {
    width: 'calc(100% + 32px)',
    marginLeft: '-16px',
    marginRight: '-16px',
    paddingLeft: '16px',
    paddingRight: '16px'
  }
}));

const IntegrationSelect = ({ integrationName, setIntegrationName }) => {
  const currentCompany = useSelector(selectCompany);
  const classes = useStyles();
  const { t } = useTranslation(['settings']);

  const handleChange = event => {
    const { value } = event.target;

    setIntegrationName(value);
  };

  return (
    <Grid item xs={12}>
      <FormControl variant="outlined" classes={{ root: classes.formControlRoot }}>
        <Select
          classes={{ root: classes.selectRoot }}
          labelId="integration"
          id="select"
          name="integration"
          value={integrationName}
          onChange={handleChange}
          sx={{ width: '100%' }}
        >
          {supportedIntegrationsByLocale[currentCompany?.locale]?.map(({ id, name, title } = {}, index) =>
            title ? (
              <MenuItem value={id} key={id}>
                <Tooltip title={t(`integrations.${title}`)}>
                  <div className={classes.optionWrapper}>{index === 0 ? t(`integrations.${name}`) : name}</div>
                </Tooltip>
              </MenuItem>
            ) : (
              <MenuItem value={id} key={id}>
                {name}
              </MenuItem>
            )
          )}
        </Select>
      </FormControl>
    </Grid>
  );
};

IntegrationSelect.propTypes = {
  integrationName: PropTypes.string,
  setIntegrationName: PropTypes.func
};

export default IntegrationSelect;
